import { callApi } from '@helpers/api';
import { keysToCamel } from '@helpers/camelCaseConverter';

const getVatNumbersRequest = agent => entity =>
  agent.get('vFlow/vatNumber/', { entity_id: entity });

const getFilingTypesRequest = agent => limit =>
  agent.get(`vFlow/filingType/?filing_existing&limit=${limit}/`);

/** @deprecated Use api/registrations instead */
export const getVatNumbers = async entity =>
  callApi(getVatNumbersRequest)(entity)
    .then(response => {
      response = keysToCamel(response);
      return response.data;
    })
    .catch(error => error);

/** @deprecated Use api/filingTypes instead */
export const getFilingTypes = async limit =>
  callApi(getFilingTypesRequest)(limit)
    .then(response => {
      response = keysToCamel(response);
      return response.data;
    })
    .catch(error => error);
